<script>
	import Graph from '$lib/icons/graph-analytics-business-2-svgrepo-com.svelte';
	import HostWebsite from '$lib/icons/host-website-se-svgrepo-com.svelte';
	import Move from '$lib/icons/move-up-svgrepo-com_change.svelte';
	import Download from '$lib/icons/download-2-svgrepo-com.svelte';
	import Network from '$lib/icons/network-mapping-svgrepo-com.svelte';
	import MetadataIcon from '$lib/icons/tag-label-svgrepo-com.svelte';
	import Stat from '$lib/icons/sum-sign-svgrepo-com.svelte';
	import Cut from '$lib/icons/cut1-round-824-svgrepo-com.svelte';
	import Change from '$lib/icons/global-warming-svgrepo-com.svelte';
	import Indicator from '$lib/icons/diagram-bar-uptrend-svgrepo-com.svelte';
	import WorkPackage from '$lib/work_package.svelte';
	import CaretRight from '$lib/icons/caret_right.svelte';

	// Workaround for missing tailwind classes
	// bg-[#D17208] border-[#D17208] decoration-[#D17208]
	// bg-[#B93F4A] border-[#B93F4A] decoration-[#B93F4A]
	// bg-[#98B1D8] border-[#98B1D8] decoration-[#98B1D8]
	// bg-[#26D7D9] border-[#26D7D9] decoration-[#26D7D9]
	// bg-[#6B9B2A] border-[#6B9B2A] decoration-[#6B9B2A]
	// bg-[#662beb] border-[#662beb] decoration-[#662beb]
</script>

<div class="content-div">
	<div class="flex items-center">
		<h1 class="content-heading">Climate Services Gateway</h1>
		<HostWebsite />
	</div>

	<blockquote class="content-blockquote mb-4">
		The Climate Services Gateway (CSG) is a platform that provides access to high resolution climate
		projections and analysis ready data for the southern African region. The Gateway development is
		still ongoing as well as the processing of datasets. Data provision is done by the Global Change
		Institute (GCI) at the University of the Witwatersrand (WITS) in South Africa and the Climate
		Service Center Germany (GERICS), Helmholtz-Center Hereon Hamburg, Germany. Postprocessing,
		indicators and CSG development are done by the Friedrich Schiller University Jena, Germany.
	</blockquote>
	<div class="mt-4 mb-4">
		<a
			href="/climate_services_gateway/collections"
			class="inline-flex items-center gap-2 px-6 py-3 text-lg bg-blue-500 text-white font-bold rounded-xl shadow-lg hover:bg-blue-600 transition-all duration-200 ease-in-out transform hover:scale-105"
		>
			<CaretRight h="24px" />
			Explore Data
		</a>
	</div>

	<div class="grid md:grid-cols-2 max-md:grid-cols-1 pt-4">
		<WorkPackage
			wp="Analysis Ready Data"
			color="#D17208"
			icon={HostWebsite}
			title="GCM & RCM data processing and analysis ready data"
			description="We provide pre-processed and analysis ready raw and bias adjusted data from 23 CMIP6 GCMs and 9 CORDEX-CORE RCMs for the
		southern African region. The data was downloaded and further processed e.g., merging of historical and future data, bias adjustment, and remappping to a common grid.
	"
			link={false}
		/>

		<WorkPackage
			wp="High Resolution Climate Projections"
			color="#B93F4A"
			icon={Move}
			title="New projections generated by GERICS and WITS"
			description="We will provide new high resolution climate projections for the southern African region."
			link={false}
		/>
		<WorkPackage
			wp="Climate Variables"
			color="#662beb"
			icon={Change}
			title="10 daily climate variables"
			description="We selected 10 climate variables needed for e.g., hydrological modelling, agriculture, and
		ecosystem modelling. The variables are: temperature (mean/min/max), precipitation, wind speed,
		humidity, and solar radiation (rlus, rlds, rsus, rsds). They are available for all data collections (GCMs and RCMs)
		for the historical period and future period (until 2100) as one time series."
			link={false}
		/>

		<WorkPackage
			wp="Indicators"
			color="#662beb"
			icon={Indicator}
			title="Climate and hydrological indicators"
			description="We provide relevant climate and hydrological indicators for the southern African region. E.g., the
		Standardized Precipitation Index (SPI) and the Standardized Precipitation Evapotranspiration Index, Water Budget,
		 and Aridity Index (AI). The indicators are available for all data provided data collections (GCMs and RCMs)."
			link={false}
		/>
		<WorkPackage
			wp="Sum/Mean Periods"
			color="#662beb"
			icon={Stat}
			title="Sum/mean 20yr and 30yr periods"
			description="We provide the mean and sum of the 20yr and 30yr periods for all GCMs and RCMs and indicators as yearly, monthly, and seasonal means/sums. In addition each daily dataset has yearly data for visualization and a quick overview."
			link={false}
		/>
		<WorkPackage
			wp="Spatial & Time Subsets"
			color="#662beb"
			icon={Cut}
			title="User-targeted subsets by region and time"
			description="We provide spatial and time subsets via the web interface. The data can be sliced for a specific region or period."
			link={false}
		/>
		<WorkPackage
			wp="Metadata"
			color="#6B9B2A"
			icon={MetadataIcon}
			title="Metadata for all datasets"
			description="For transparency and reproducibility we provide extended and adjusted metadata for all datasets. Metadata is currently not available and stored for all datasets but will be provided in the future."
			link={false}
		/>
		<WorkPackage
			wp="Provenance"
			color="#6B9B2A"
			icon={Network}
			title="Provenance information for all datasets"
			description="For transparency and reproducibility we provide provenance information for all datasets. Processing steps are documented and stored in the Climate Services Gateway within a provenance graph."
			link={false}
		/>
		<WorkPackage
			wp="Visualization"
			color="#6B9B2A"
			icon={Graph}
			title="Map and time series visualization"
			description="We provide a map and time series visualization of the data.
			The map visualization is based on a GeoTIIFF file which is generated from the NetCDF file on demand. Coloring is changeable and based on the IPCC color palette. The map visualization is interactive and allows zooming and panning.
			The time series visualization is based on the GeoTIFF file and is enhanced with a trend and moving average.
			"
			link={false}
		/>
		<WorkPackage
			wp="Download"
			color="#6B9B2A"
			icon={Download}
			title="Mass or individual download of data"
			description="All data can be downloaded as NetCDF files, text or Geotiff files (for small datasets) as single files or using WGET. On request data can be slice for a specific region or
		period."
			link={false}
		/>

		<span class="bg-[#662beb] border-[#662beb] decoration-[#662beb]" />
		<!--
		bg-[#662beb] border-[#662beb] decoration-[#662beb]-->
		<!--		<div
			class="card p-4 m-1 border border-5 border-[#8B910A] mt-5

    "
		>
		<div class="flex">
				<img src="static/images/leadership-svgrepo-com.svg" alt="..." width="30px" />
				<b class="text-lg underline underline-offset-4 decoration-[#8B910A] ml-2">General Facts</b>
			</div>
			<blockquote class="mt-1 text-sm">
				<ul class="list">
					<li>
						<span>&#8226;</span>
						<span class="flex-auto"
							><span class="font-bold pr-4">Project leader:</span>Francois Engelbrecht</span
						>
					</li>
					<li>
						<span>&#8226;</span>
						<span class="flex-auto"
							><span class="font-bold pr-4">Project period:</span> 3 years</span
						>
					</li>
					<li>
						<span>&#8226;</span>
						<span class="flex-auto"
							><span class="font-bold pr-4">Project founder:</span>BMBF ..</span
						>
					</li>
				</ul>
			</blockquote>
		</div>-->
	</div>
</div>
